/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { CompanySearchAddress } from './';
import {
    CompanySearchAddressFromJSON,
    CompanySearchAddressFromJSONTyped,
    CompanySearchAddressToJSON,
} from './';
import type { LegalInformationProvider } from './';
import {
    LegalInformationProviderFromJSON,
    LegalInformationProviderFromJSONTyped,
    LegalInformationProviderToJSON,
} from './';

/**
 * 
 * @export
 * @interface LegalInformationSearchResponse
 */
export interface LegalInformationSearchResponse {
    /**
     * 
     * @type {string}
     * @memberof LegalInformationSearchResponse
     */
    name?: string;
    /**
     * 
     * @type {CompanySearchAddress}
     * @memberof LegalInformationSearchResponse
     */
    address: CompanySearchAddress;
    /**
     * 
     * @type {string}
     * @memberof LegalInformationSearchResponse
     */
    registrationNumber: string;
    /**
     * 
     * @type {string}
     * @memberof LegalInformationSearchResponse
     */
    hqRegistrationCity?: string;
    /**
     * 
     * @type {LegalInformationProvider}
     * @memberof LegalInformationSearchResponse
     */
    provider: LegalInformationProvider;
    /**
     * 
     * @type {string}
     * @memberof LegalInformationSearchResponse
     */
    externalId: string;
}

/**
 * Check if a given object implements the LegalInformationSearchResponse interface.
 */
export function instanceOfLegalInformationSearchResponse(value: object): value is LegalInformationSearchResponse {
    if (!('address' in value) || value['address'] === undefined) return false;
    if (!('registrationNumber' in value) || value['registrationNumber'] === undefined) return false;
    if (!('provider' in value) || value['provider'] === undefined) return false;
    if (!('externalId' in value) || value['externalId'] === undefined) return false;
    return true;
}

export function LegalInformationSearchResponseFromJSON(json: any): LegalInformationSearchResponse {
    return LegalInformationSearchResponseFromJSONTyped(json, false);
}

export function LegalInformationSearchResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): LegalInformationSearchResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'address': CompanySearchAddressFromJSON(json['address']),
        'registrationNumber': json['registrationNumber'],
        'hqRegistrationCity': json['hqRegistrationCity'] == null ? undefined : json['hqRegistrationCity'],
        'provider': LegalInformationProviderFromJSON(json['provider']),
        'externalId': json['externalId'],
    };
}

export function LegalInformationSearchResponseToJSON(value?: LegalInformationSearchResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
        'address': CompanySearchAddressToJSON(value['address']),
        'registrationNumber': value['registrationNumber'],
        'hqRegistrationCity': value['hqRegistrationCity'],
        'provider': LegalInformationProviderToJSON(value['provider']),
        'externalId': value['externalId'],
    };
}

